"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convert = exports.getSymbol = exports.SYMBOL_MAP = exports.getLabel = exports.LABEL_MAP = exports.Temperature = exports.UsTemperature = exports.ImperialTemperature = exports.SiTemperature = exports.Fahrenheit = exports.Decicelsius = exports.Celsius = exports.CELSIUS_ABSOLUTE_ZERO = exports.Kelvin = exports.NAMESPACE = void 0;
const effect_1 = require("effect");
exports.NAMESPACE = 'Unit.Temperature';
exports.Kelvin = effect_1.Schema.TaggedStruct('Kelvin', {
    amount: effect_1.Schema.NonNegative,
}).annotations({
    identifier: `${exports.NAMESPACE}.Kelvin`,
});
exports.CELSIUS_ABSOLUTE_ZERO = -273.15;
exports.Celsius = effect_1.Schema.TaggedStruct('Celsius', {
    amount: effect_1.Schema.Number.pipe(effect_1.Schema.greaterThanOrEqualTo(exports.CELSIUS_ABSOLUTE_ZERO)),
}).annotations({
    identifier: `${exports.NAMESPACE}.Celsius`,
});
exports.Decicelsius = effect_1.Schema.TaggedStruct('Decicelsius', {
    amount: effect_1.Schema.Number.pipe(effect_1.Schema.greaterThanOrEqualTo(exports.CELSIUS_ABSOLUTE_ZERO * 10)),
}).annotations({
    identifier: `${exports.NAMESPACE}.Decicelsius`,
});
exports.Fahrenheit = effect_1.Schema.TaggedStruct('Fahrenheit', {
    amount: effect_1.Schema.Number.pipe(effect_1.Schema.greaterThanOrEqualTo(-459.67)),
}).annotations({
    identifier: `${exports.NAMESPACE}.Fahrenheit`,
});
exports.SiTemperature = effect_1.Schema.Union(exports.Kelvin, exports.Celsius, exports.Decicelsius).annotations({
    identifier: `${exports.NAMESPACE}.SiTemperature`,
});
exports.ImperialTemperature = effect_1.Schema.Union(exports.Kelvin, exports.Celsius).annotations({
    identifier: `${exports.NAMESPACE}.ImperialTemperature`,
});
exports.UsTemperature = effect_1.Schema.Union(exports.Fahrenheit).annotations({
    identifier: `${exports.NAMESPACE}.UsTemperature`,
});
exports.Temperature = effect_1.Schema.Union(...exports.SiTemperature.members, ...exports.ImperialTemperature.members, exports.UsTemperature).annotations({
    identifier: `${exports.NAMESPACE}.Temperature`,
});
exports.LABEL_MAP = {
    Kelvin: 'kelvin',
    Celsius: 'Celsius',
    Decicelsius: 'Decicelsius',
    Fahrenheit: 'Fahrenheit',
};
/**
 * Retrieves the label corresponding to a given {@link Temperature}-tag
 */
const getLabel = (tag) => exports.LABEL_MAP[tag];
exports.getLabel = getLabel;
exports.SYMBOL_MAP = {
    Kelvin: 'K',
    Celsius: '°C',
    Decicelsius: 'd°C',
    Fahrenheit: '°F',
};
/**
 * Retrieves the symbol corresponding to a given {@link Temperature}-tag
 */
const getSymbol = (tag) => exports.SYMBOL_MAP[tag];
exports.getSymbol = getSymbol;
const toKelvin = effect_1.Match.type().pipe(effect_1.Match.withReturnType(), effect_1.Match.tag('Kelvin', kelvin => kelvin), effect_1.Match.tag('Celsius', ({ amount }) => exports.Kelvin.make({ amount: amount - exports.CELSIUS_ABSOLUTE_ZERO })), effect_1.Match.tag('Decicelsius', ({ amount }) => toKelvin(exports.Celsius.make({ amount: amount / 10 }))), effect_1.Match.tag('Fahrenheit', ({ amount }) => exports.Kelvin.make({ amount: ((amount + 459.67) * 5) / 9 })), effect_1.Match.exhaustive);
/**
 * Converts any {@link Temperature} to a specific temperature measure
 */
exports.convert = effect_1.Function.dual(2, (temperature, outTag) => {
    const kelvin = toKelvin(temperature);
    return {
        _tag: outTag,
        amount: effect_1.Match.value(outTag).pipe(effect_1.Match.withReturnType(), effect_1.Match.when('Kelvin', () => kelvin.amount), effect_1.Match.when('Celsius', () => kelvin.amount + exports.CELSIUS_ABSOLUTE_ZERO), effect_1.Match.when('Decicelsius', () => (kelvin.amount + exports.CELSIUS_ABSOLUTE_ZERO) * 10), effect_1.Match.when('Fahrenheit', () => (kelvin.amount * 9) / 5 - 459.67), effect_1.Match.exhaustive),
    };
});
//# sourceMappingURL=temperature.js.map